import { Step, StepLabel, Stepper } from "@mui/material";
import { useIntl } from "react-intl";

const styles = {
  stepper: {
    mb: 3,
    maxWidth: 640,
  },
};

const stepLabelKeys = [
  "importsStepUploadLabel",
  "importsStepMapLabel",
  "importsStepProcessLabel",
];

export default function ImportsStepper({
  activeStep,
}: Readonly<{ activeStep: number }>) {
  const { formatMessage: t } = useIntl();

  return (
    <Stepper activeStep={activeStep} sx={styles.stepper}>
      {stepLabelKeys.map((key) => (
        <Step key={key}>
          <StepLabel>{t({ id: key })}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
